import { apiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'

export const getArcAds = ({ page, search, filters, sorter }) => {
  return apiInstance
    .get(`/arc_ads?include=arc_advertiser`,
      {params: {
        filter: {
          search: search ? encodeURIComponent(search) : null,
          ...filters,
        },
        ...sorter,
        page: {
          number: page,
          size: 20,
        }},
        headers: {
          'Accept': 'application/vnd.api+json',
        }
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc ads')
    })
}

export const getArcAdSources = () => {
  return apiInstance
    .get('/arc_ads/sources', {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc ad sources')
    })
}

export const getArcAd = (id) => {
  return apiInstance
    .get(`/arc_ads/${id}?include=arc_advertiser`, {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc ad')
    })
}

export const createArcAd = (data) => {
  return apiInstance
    .post('/arc_ads', {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc ad hasn't been created")
    })
}

export const updateArcAd = (data) => {
  return apiInstance
    .put(`/arc_ads/${data.id}`, {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc ad hasn't been updated")
    })
}

export const deleteArcAd = (id) =>
  apiInstance
    .delete(`/arc_ads/${id}`)
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc ad hasn't been deleted")
    })